import { render, staticRenderFns } from "./RequestPerDayInAMonthBarChart.vue?vue&type=template&id=fd0787e0&scoped=true&"
import script from "./RequestPerDayInAMonthBarChart.vue?vue&type=script&lang=js&"
export * from "./RequestPerDayInAMonthBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0787e0",
  null
  
)

export default component.exports